import { useSelector } from 'react-redux';
import { useAdministrativeContext } from '../../../../pages/administrativePanel/administrativePanelContext';
import { Container } from './style';

export function CoverPage() {
  const isOpenModalForms = useSelector(state => { 
    return state.modalForms.isOpen 
  })

  const { 
    openSideBar, 
    setOpenSideBar, 
    setOpenSubMenu,
    setOpenDrop
 } = useAdministrativeContext()


  return <Container   
    openSideBar={openSideBar} 
    isOpenModalForms={isOpenModalForms}

    onClick={() => {
      if(openSideBar)
        setOpenSideBar(false)
        setOpenSubMenu(false)
        setOpenDrop(false)
    }}

  />
}
